<template>
  <div class="about"
       id="abouttop">
    <En_topper></En_topper>
    <div class="nei_tit">
      <img src="../assets/about_tit.jpg"
           alt="" />
      <span>About ENN</span>
    </div>

    <!-- 集团简介 -->
    <div class="jtjj_wrapper"
         id="jtjj"
         style="height:25rem;">
      <h2>Group Overview</h2>
      <p>
        Founded in 1989 in Langfang, Hebei, ENN began with urban gas services
        and gradually expanded to cover the entire natural gas value chain,
        including distribution, trading, transportation, storage, production,
        and engineering intelligent manufacturing, thereby establishing a fully
        integrated clean energy ecosystem. Guided by the pursuit of a better
        life, ENN has diversified into sectors such as real estate, tourism,
        culture, and health, creating high-quality living environments.
      </p>
      <p>
        In the intelligent era, ENN is actively advancing its digital
        transformation. Driven by the demand for "high-quality, low carbon, and
        intelligence" from both household users and corporate clients, ENN has
        developed intelligent platforms such as ENNEW.com for smart production
        and operations, and various industry-specific platforms including
        Greatgas.cn, FANNENG.com, JUAN.CN, zc.ygyg.cn, and ENOWA. These
        platforms focus on integrating IoT sensors, large-scale models, and
        robotics to create a seamless system of "perception, cognition, and
        action." For household users, ENN provides intelligent home services
        tailored to high-quality living needs. For corporate clients, ENN
        delivers comprehensive intelligent solutions that address the problems
        including safety, energy efficiency, low carbon, and quality, ensuring
        overall success and optimal performance.
      </p>
      <p>
        Currently, ENN provides energy services to more than 31 million
        households and over 270,000 enterprises across 21 provinces in China.
        The group has four publicly listed companies: ENN Energy (02688.HK), ENN
        Natural Gas Co.. Ltd. (600803.SH), ENC Digital Technology Co.,Ltd.
        (603869.SH), and Tibet Tourism (600749.SH).
      </p>
      <dl>
        <dt>40,000+</dt>
        <dd>Current Employees</dd>
      </dl>
      <dl>
        <dt>
          <i style="font-size:.25rem">CNY</i>150.1<i style="font-size:.25rem">Billion</i>
        </dt>
        <dd>2025 Operating Revenue</dd>
      </dl>
      <dl style="border-right:0;">
        <dt>22 <i>Provinces</i></dt>
        <dd>Domestic Business Presence</dd>
      </dl>
    </div>

    <!-- 企业文化 -->
    <div class="qywh_wrapper"
         id="qywh">
      <h2>Corporate Culture</h2>
      <dl>
        <dt>ENN Philosophy</dt>
        <dd style="font-size:.29rem; line-height:100%;">
          Client-Centric, Achieving Mutual Success, Co-Creating an Ecosystem
        </dd>
      </dl>
      <dl>
        <dt>Mission and Vision</dt>
        <dd style="font-size:.29rem; line-height:100%;">
          Build a Demand-Supply Relationship with Intelligence<br />
          Create a Modern Energy System, Enhance the Quality of Consumers'
          Life<br />
          Become a Respected, Innovative, and Intelligent Enterprise
        </dd>
      </dl>
      <dl>
        <dt>ENN Core Values</dt>
        <dd style="font-size:.29rem; line-height:100%;">
          Integrity, Self-Driven Excellence, Altruistic Coexistence, Success
          through digital Intelligence
        </dd>
      </dl>
    </div>

    <!-- 社会责任 -->
    <div class="shzr_wrapper"
         id="shzz"
         style="height:33.23rem;">
      <h2>Social Responsibility</h2>
      <div class="shzr_con">
        <img src="../assets/hjzr.jpg"
             alt="" />
        <h3>Environmental Responsibility</h3>
        <p>
          Promoting clean energy solutions to reduce emissions and energy
          consumption, contributing to a healthier environment with clearer
          skies and cleaner waters.
        </p>
      </div>
      <div class="shzr_con">
        <img src="../assets/jyns.jpg"
             alt="" />
        <h3>Employment & Tax Contributions</h3>
        <p>
          With over 40,000 employees, ENN drives growth with its ecosystem
          partners, continually expanding employment opportunities and
          contributing actively to the tax base.
        </p>
      </div>
      <div class="shzr_con">
        <img src="../assets/cssy.jpg"
             alt="" />
        <h3>Corporate Social Responsibility</h3>
        <p>
          Actively engaged in disaster relief, poverty alleviation, and
          educational donations, with a focus on targeted efforts in industrial
          and educational support for poverty reduction.
        </p>
      </div>
    </div>

    <!-- 发展历程 -->
    <div class="fzlc_wrapper"
         id="fzlc">
      <h2>Development History</h2>
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <span>1989</span>
            <p>Founded in Langfang, Hebei</p>
          </div>
          <div class="swiper-slide">
            <span>1993</span>
            <p>Connected pipeline natural gas to Langfang Development Zone</p>
          </div>
          <div class="swiper-slide">
            <span>1994</span>
            <p>Entered real estate to meet employee housing needs</p>
          </div>
          <div class="swiper-slide">
            <span>1999</span>
            <p>Expanded urban gas services nationwide</p>
          </div>
          <div class="swiper-slide">
            <span>2001</span>
            <p>Listed ENN Gas on the Hong Kong Stock Exchange</p>
          </div>
          <div class="swiper-slide">
            <span>2004</span>
            <p>
              Ventured upstream into energy, developing proprietary coal-to-gas
              technology
            </p>
          </div>
          <div class="swiper-slide">
            <span>2009</span>
            <p>Launched clean energy solutions for emissions reduction</p>
          </div>
          <div class="swiper-slide">
            <span>2010</span>
            <p>Introduced and implemented the FANNENG.com concept</p>
          </div>
          <div class="swiper-slide">
            <span>2011</span>
            <p>
              Launched the ENNOVA brand, expanding into the cultural and tourism
              sectors
            </p>
          </div>
          <div class="swiper-slide">
            <span>2015</span>
            <p>Launched "Greatgas.cn"</p>
          </div>
          <div class="swiper-slide">
            <span>2016</span>
            <p>
              Established ENC Digital Technology Co.,Ltd. to strengthen
              intelligent capabilities
            </p>
          </div>
          <div class="swiper-slide">
            <span>2018</span>
            <p>Commissioned ENN Zhoushan LNG Terminal</p>
          </div>
          <div class="swiper-slide">
            <span>2019</span>
            <p>
              Initiated compact nuclear fusion research and founded Laikang
              Life, expanding into smart healthcare
            </p>
          </div>
          <div class="swiper-slide">
            <span>2020</span>
            <p>
              Transformed ENN headquarters into ENNEW, building and operating
              digital intelligence platforms
            </p>
          </div>
          <div class="swiper-slide">
            <span>2021</span>
            <p>
              Launched the ENNEW.com platform and invested in the construction
              of an IoT sensing industrial park in Tianjin
            </p>
          </div>
          <div class="swiper-slide">
            <span>2022</span>
            <p>Formed ENNEW SENSING</p>
          </div>
          <div class="swiper-slide">
            <span>2023</span>
            <p>Completed strategic layout for intelligent transformation</p>
          </div>
          <div class="swiper-slide">
            <span>2024</span>
            <p>
              Launched the "Demand-Supply Co-Intelligence, Excellence in
              Commerce" concept and business model
            </p>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- Swiper -->
    </div>

    <!-- 领导团队 -->
    <div class="ldtd_wrapper "
         id="ldtd"
         style="height:57.23rem;">
      <h2>Leadership Team</h2>
      <ul>
        <li>
          <img src="../assets/leaders/wangyusuo.jpg" />
          <div class="ldtd_text">
            <span>Mr. Wang Yusuo</span>
            <p>Board Chairman of the ENN Group</p>
            <p>
              PhD in Business Management from Tianjin University of Finance and
              Economics.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/yujianchao.jpg" />
          <div class="ldtd_text">
            <span>Mr. Yu Jianchao</span>
            <p>Chairman of the ENN Group</p>
            <p>
              MBA from China Europe International Business School (CEIBS) and
              EMBA from Tsinghua University.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/zhangjin.jpg" />
          <div class="ldtd_text">
            <span>Ms. Zhang Jin</span>
            <p>Vice Chairman of the ENN Group</p>
            <p>
              Master’s degree in Business Management from Renmin University of
              China.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/wangzizheng.jpg" />
          <div class="ldtd_text">
            <span>Mr. Wang Zizheng</span>
            <p>Director of ENN Group</p>
            <p>Degree in Urban Planning from Tongji University.</p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/wangdongzhi.jpg" />
          <div class="ldtd_text">
            <span>Mr. Wang Dongzhi</span>
            <p>Director of ENN Group</p>
            <p>
              Master’s degree in Business Administration from Tianjin
              University, certified public accountant in China.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/yangyu.jpg" />
          <div class="ldtd_text">
            <span>Mr. Yang Yu</span>
            <p>Director of ENN Group</p>
            <p style="line-height: 130%;">
              Degree in Radio Communications from Petroleum Pipeline Vocational
              College, Master’s degree in Monetary Banking from Renmin
              University of China, and EMBA from Nanyang Technological
              University in Singapore.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/zhangyuying.jpg" />
          <div class="ldtd_text">
            <span>Mr. Zhang Yuying</span>
            <p>Director of ENN Group</p>
            <p style="line-height: 130%;">
              Master’s degree in Business Administration from Renmin University
              of China, EMBA from Peking University.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/jinyongsheng.jpg" />
          <div class="ldtd_text">
            <span>Mr. Jin Yongsheng</span>
            <p>Director of ENN Group</p>
            <p>
              Degree in Finance from Tianjin University of Finance and
              Economics, EMBA from Peking University, licensed lawyer in China.
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/jiangchenghong.jpg" />
          <div class="ldtd_text">
            <span>Mr. Jiang Chenghong</span>
            <p>Director of ENN Group</p>
            <p>
              Degree in Finance and Insurance from Wuhan University; MBA from
              the University of Saskatchewan (Canada); EMBA from Xiamen
              University. Licensed lawyer in China.
            </p>
          </div>
        </li>
        <!-- <li>
          <img src="../assets/leaders/zhaojinfeng.jpg">
          <div class="ldtd_text">
            <span>Mr. Zhao Jinfeng</span>
            <p>Director of ENN Group</p>
            <p>EMBA from China Europe International Business School (CEIBS).</p>
          </div>
        </li> -->
        <!--li>
          <img src="../assets/leaders/guojijun.jpg">
          <div class="ldtd_text">
            <span>Mr. Guo Jijun</span>
            <p>Director of ENN Group, CEO and President of ENNEW</p>
            <p>Master’s degree in Computer Networking from Shanghai Jiao Tong University.</p>
          </div>
        </li-->
        <!-- <li>
          <img src="../assets/leaders/hanjishen.jpg">
          <div class="ldtd_text">
            <span>Mr. Han Jishen</span>
            <p>Director of ENN Group, Co-CEO of ENN Natural Gas Co.. Ltd.</p>
            <p>EMBA from Nanyang Technological University in Singapore."</p>
          </div>
        </li> -->
      </ul>
    </div>

    <!-- 股票信息 -->
    <div class="gpxx_wrapper"
         id="gpxx"
         style="height:29.31rem;">
      <h2>Stock Information</h2>
      <ul>
        <li v-if="elements0 && elements0.length > 0">
          <img src="../assets/02688.jpg"
               alt="" />
          <span class="gp_mingzi">ENN Energy</span>
          <span class="gp_daima">02688.HK</span>
          <span :class="
              'gp_jiage ' +
                (elements0[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements0[3]).toFixed(2) }}<i>HKD</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements0[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements0[32]).toFixed(2) }}%</span>
          <!-- <span class="gp_gaozui">最高<i class="red">{{parseFloat(elements0[33]).toFixed(2)}}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{parseFloat(elements0[34]).toFixed(2)}}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{(parseFloat(elements0[37])/10000).toFixed(2)}}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{(parseFloat(elements0[36])/10000).toFixed(2)}}万股</i></span> -->
        </li>
        <li v-if="elements1 && elements1.length > 0">
          <img src="../assets/600803.jpg"
               alt="" />
          <span class="gp_mingzi">ENN Natural Gas Co.,Ltd.</span>
          <span class="gp_daima">600803.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements1[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements1[3]).toFixed(2) }}<i>CNY</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements1[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements1[32]).toFixed(2) }}%</span>
          <!-- <span class="gp_gaozui">最高<i class="red">{{parseFloat(elements1[33]).toFixed(2)}}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{parseFloat(elements1[34]).toFixed(2)}}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{(parseFloat(elements1[37])).toFixed(2)}}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{(parseFloat(elements1[36])/10000).toFixed(2)}}万股</i></span> -->
        </li>
        <li v-if="elements2 && elements2.length > 0">
          <img src="../assets/603869.jpg"
               alt="" />
          <span class="gp_mingzi">ST智知</span>
          <span class="gp_daima">603869.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements2[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements2[3]).toFixed(2) }}<i>CNY</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements2[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements2[32]).toFixed(2) }}%</span>
          <!-- <span class="gp_gaozui">最高<i class="red">{{parseFloat(elements2[33]).toFixed(2)}}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{parseFloat(elements2[34]).toFixed(2)}}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{(parseFloat(elements2[37])).toFixed(2)}}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{(parseFloat(elements2[36])/10000).toFixed(2)}}万股</i></span> -->
        </li>
        <li v-if="elements3 && elements3.length > 0">
          <img src="../assets/600749.jpg"
               alt="" />
          <span class="gp_mingzi">Tibet Tourism</span>
          <span class="gp_daima">600749.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements3[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements3[3]).toFixed(2) }}<i>CNY</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements3[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements3[32]).toFixed(2) }}%</span>
          <!-- <span class="gp_gaozui">最高<i class="red">{{parseFloat(elements3[33]).toFixed(2)}}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{parseFloat(elements3[34]).toFixed(2)}}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{(parseFloat(elements3[37])).toFixed(2)}}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{(parseFloat(elements3[36])/10000).toFixed(2)}}万股</i></span> -->
        </li>
      </ul>
    </div>

    <!--底部-->
    <En_footer></En_footer>
  </div>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";
import En_topper from "./En_topper";
import En_footer from "./En_footer";
export default {
  components: {
    En_topper,
    En_footer
  },
  name: "En_about",
  data () {
    return {
      elements0: [],
      elements1: [],
      elements2: [],
      elements3: []
    };
  },
  methods: {
    loadUrl () {
      //   let url = 'https://qt.gtimg.cn/q=hk02688,sh600803,sh603869,sh600749'
      let url = "/qtapi/q=hk02688,sh600803,sh603869,sh600749";
      axios
        .get(url)
        .then(response => {
          let strArray = response.data.split(";");
          this.elements0 = strArray[0].split("~");
          this.elements1 = strArray[1].split("~");
          this.elements2 = strArray[2].split("~");
          this.elements3 = strArray[3].split("~");

          //跳锚点
          let maodian = this.$route.params.maodian;
          console.log(maodian);
          if (maodian) {
            this.$nextTick(() => {
              const targetElement = document.querySelector(maodian);
              window.scrollTo({
                top: targetElement.offsetTop - 45,
                behavior: "smooth"
              });
            });
          } else {
            window.scrollTo(0, 0);
          }
        })

        .catch(error => {
          console.error("There was an error fetching the content:", error);
        });
    }
  },
  mounted () {
    new Swiper(".swiper-container", {
      loop: false,
      // 如果需要分页器
      //   pagination: ".swiper-pagination",
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: "auto",
      //   autoplay: 3000,
      autoplayDisableOnInteraction: false //用户操作后是否自动播放
      //   parallax: true,//允许延迟
    });

    this.loadUrl();
  }
};
</script>

<style scoped>
.about {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
.jtjj_wrapper {
  padding: 0 40px;
  width: 670px;
  height: auto;
  overflow: hidden;
  float: left;
}
.about h2 {
  width: 100%;
  height: auto;
  font-size: 36px;
  color: #1d2129;
  text-align: left;
  padding-top: 65px;
  padding-bottom: 30px;
}
.about p {
  width: 100%;
  height: auto;
  font-size: 28px;
  color: #1d2129;
  text-align: left;
  margin-bottom: 50px;
  line-height: 150%;
}
.jtjj_wrapper dl {
  width: 200px;
  height: auto;
  float: left;
  padding: 0 10px;
  border-right: 1px solid #ddd;
}
.jtjj_wrapper dl dt {
  color: #003f84;
  font-size: 40px;
  font-family: dingding;
  padding-bottom: 10px;
}
.jtjj_wrapper dl dd {
  color: #1d2129;
  font-size: 20px;
}
.jtjj_wrapper dl dt i {
  font-style: normal;
  font-size: 25px;
  font-weight: 600;
}

.qywh_wrapper {
  width: 670px;
  height: 420px;
  background: url(../assets/qywh_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  float: left;
  margin-top: 60px;
  padding: 60px 40px;
}
.qywh_wrapper h2 {
  padding-top: 0;
  padding-bottom: 50px;
  color: #fff;
}
.qywh_wrapper dl {
  width: 650px;
  float: left;
  margin-bottom: 30px;
}
.qywh_wrapper dl dt {
  width: 190px;
  float: left;
  font-size: 28px;
  color: #fff;
  font-weight: 600;
  text-align: left;
}
.qywh_wrapper dl dd {
  width: 460px;
  float: left;
  font-size: 26px;
  color: #fff;
  text-align: left;
  line-height: 180%;
}

/* 社会职责 */
.shzr_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
}
.shzr_wrapper h2 {
  width: 710px;
  padding-left: 40px;
}
.shzr_wrapper img {
  width: 750px;
}
.shzr_wrapper h3 {
  width: 710px;
  padding: 35px 0 10px 40px;
  font-size: 36px;
  text-align: left;
}
.shzr_wrapper .shzr_con {
  border-bottom: 24px solid #f1f2f6;
}
.shzr_wrapper .shzr_con p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  display: block;
  padding: 5px 40px;
}

/* 发展历程 */
.fzlc_wrapper {
  width: 750px;
  height: 650px;
  background: url(../assets/fzlc_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  float: left;
  border-top: 35px solid #f1f2f6;
}
.fzlc_wrapper h2 {
  width: 710px;
  padding-left: 40px;
}
.swiper-container {
  width: 710px;
  height: 300px;
  margin-top: 60px;
  padding-left: 40px;
}

.swiper-wrapper {
  width: 710px;
  height: 400px;
}
.swiper-container .swiper-slide {
  width: 320px;
  height: 400px;
  position: relative;
  float: left;
  background: url(../assets/fzlc_libg.png) 0 250px no-repeat;
}

.swiper-container .swiper-slide span {
  height: auto;
  display: block;
  text-align: left;
  overflow: hidden;
  font-size: 64px;
  padding-bottom: 15px;
  color: #003f84;
  font-weight: 600;
  font-family: dingding;
}
.swiper-container .swiper-slide p {
  width: 260px;
  height: auto;
  display: block;
  text-align: left;
  overflow: hidden;
  font-size: 22px;
  line-height: 25px;
  color: #1d2129;
}

/* 领导团队 */
.ldtd_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
  background: #f1f2f6;
}
.ldtd_wrapper h2 {
  padding-left: 40px;
  width: 710px;
  padding-top: 60px;
  padding-bottom: 50px;
}
.ldtd_wrapper li {
  width: 750px;
  height: auto;
  float: left;
  background: #fff;
  margin-bottom: 25px;
}
.ldtd_wrapper li img {
  width: 330px;
  height: 330px;
  float: left;
}
.ldtd_wrapper li .ldtd_text {
  width: 340px;
  height: auto;
  float: left;
  padding: 40px;
}
.ldtd_wrapper li .ldtd_text span {
  font-size: 32px;
  text-align: left;
  color: #1d2129;
  display: block;
  font-weight: 600;
}
.ldtd_wrapper li .ldtd_text p {
  display: block;
  padding-bottom: 24px;
  font-size: 28px;
  color: #323233;
  margin: 0;
  line-height: 140%;
}

/* 股票信息 */
.gpxx_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
  background: #f1f2f6;
}
.gpxx_wrapper h2 {
  padding-left: 40px;
  width: 710px;
  padding-top: 60px;
  padding-bottom: 50px;
}
.gpxx_wrapper li {
  width: 750px;
  height: 485px;
  float: left;
  background: #fff;
  margin-bottom: 25px;
  position: relative;
}
.gpxx_wrapper li img {
  width: 750px;
  height: 330px;
  float: left;
  position: absolute;
  left: 0;
  top: 0;
}
.gpxx_wrapper li .gp_mingzi {
  width: 750px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  left: 0;
  top: 125px;
  display: block;
}
.gpxx_wrapper li .gp_daima {
  display: block;
  width: 750px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  left: 0;
  top: 180px;
}
.gpxx_wrapper li .gp_jiage {
  display: block;
  position: absolute;
  width: 210px;
  height: 40px;
  font-weight: 900;
  font-size: 40px;
  left: 40px;
  top: 360px;
  text-align: left;
}
.gpxx_wrapper li .gp_jiage i {
  font-size: 24px;
  font-style: normal;
}
.gpxx_wrapper li .green {
  color: #308f40;
}
.gpxx_wrapper li .red {
  color: #cc4646;
}
.gpxx_wrapper li .gp_zhangfu {
  display: block;
  position: absolute;
  width: 170px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  left: 40px;
  top: 415px;
  font-size: 24px;
}
.gpxx_wrapper li .greenbg {
  background: #308f40;
  color: #fff;
}
.gpxx_wrapper li .redbg {
  background: #cc4646;
  color: #fff;
}
.gpxx_wrapper li .gp_gaozui {
  display: block;
  position: absolute;
  width: 190px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 270px;
  top: 370px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_zuidi {
  display: block;
  position: absolute;
  width: 190px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 270px;
  top: 415px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_gaozui i,
.gpxx_wrapper li .gp_zuidi i,
.gpxx_wrapper li .gp_chengjiaoe i,
.gpxx_wrapper li .gp_chengjiaoliang i {
  font-style: normal;
  padding-left: 15px;
}
.gpxx_wrapper li .gp_chengjiaoe {
  display: block;
  position: absolute;
  width: 250px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 465px;
  top: 370px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_chengjiaoliang {
  display: block;
  position: absolute;
  width: 250px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 465px;
  top: 415px;
  font-size: 28px;
  color: #323233;
}
</style>
